import $ from 'jquery';

export default {
    init() {
        $('.ai-block-assessment-tool').each(function () {
            const parent = $(this),
                quiz = parent.find('.quiz');

            const cleanErrors = () => {
                quiz.find('.error').text('');
                quiz.slick('setPosition');
            }

            const firstStepCheck = () => {
                let sum = 0;
                quiz.find('.setting-value .value').each(function () {
                    sum += +($(this).text().replace('%', ''));
                });
                if (sum !== 100) {
                    quiz.find('.error').text(`The total is ${sum}%, but it should be equal to 100%`);
                    quiz.find('.success').hide();
                    quiz.slick('setPosition');
                } else {
                    quiz.find('.success').show();
                    cleanErrors();
                }

                return sum === 100;
            }

            const stepCheck = () => {
                const currentIndex = +quiz.find('.slick-current').attr('data-slick-index');
                if (currentIndex === 0) return false;

                const names = [];

                quiz.find(`.slick-slide[data-slick-index="${currentIndex}"] input:radio`).each(function () {
                    let myname = this.name;
                    if ($.inArray(myname, names) < 0) {
                        names.push(myname);
                    }
                });

                let correct = true;
                $.each(names, function (i, name) {
                    if (!quiz.find(`.slick-slide[data-slick-index="${currentIndex}"] input[name="${name}"]:checked`).val()) {
                        correct = false;
                        return false;
                    }
                });

                if (!correct) {
                    quiz.find('.error').text(`Answer to all the questions to go to the next step`);
                    quiz.slick('setPosition');
                } else {
                    cleanErrors();
                }

                return correct;
            }

            quiz.find('.range-slider').each(function () {
                const slider = $(this);

                rangeSlider(this, {
                    value: [0, +slider.attr('data-default_value')],
                    thumbsDisabled: [true, false],
                    rangeSlideDisabled: true,
                    onInput: v => {
                        slider.closest('.setting').find('.setting-value .value').text(`${v[1]}%`);
                        slider.closest('.setting').find('input[name]').val(`${v[1]}`);
                        firstStepCheck();
                    },
                    onThumbDragStart: () => {
                        slider.closest('.setting').addClass('active')
                    },
                    onThumbDragEnd: () => {
                        slider.closest('.setting').removeClass('active')
                    }
                })
            });

            parent.find('input').change(function () {
                quiz.find('.error').text('');
                quiz.slick('setPosition');
            });

            const goTo = (index) => {
                const currentIndex = +quiz.find('.slick-current').attr('data-slick-index');

                if (currentIndex < index) {
                    if (currentIndex === 0) {
                        if (!firstStepCheck()) return;
                    } else {
                        if (!stepCheck()) return;
                    }
                } else {
                    cleanErrors();
                }

                if(index > quiz.find('.slick-slide').length - 1) {
                    quiz.submit();
                    return;
                }

                parent.find('aside li').each(function (i) {
                    $(this).removeClass('prev').removeClass('current')
                    if (index > i) {
                        $(this).addClass('prev');
                    } else if (index === i) {
                        $(this).addClass('current');
                    }
                });

                quiz.slick('slickGoTo', index);
                $("html, body")
                    .stop()
                    .animate(
                        {
                            scrollTop: parent.offset().top,
                        },
                        500
                    );
            }

            quiz.slick({
                accessibility: false,
                infinite: false,
                arrows: false,
                swipe: false,
                adaptiveHeight: true,
                speed: 0,
            });
            parent.find('aside a').click(function (e) {
                e.preventDefault();
                const index = parent.find('aside li').index($(this).closest('li'));
                goTo(index);
            });
            quiz.find('.prev').click(function (e) {
                e.preventDefault();
                const index = quiz.find('.step').index($(this).closest('.step'));
                goTo(index - 1);
            });
            quiz.find('.next').click(function (e) {
                e.preventDefault();
                const index = quiz.find('.step').index($(this).closest('.step'));
                goTo(index + 1);
            });
        });
    },
    finalize() {
    },
};
